import {
  MonthReport,
  PaybackReport,
  ProductStats,
  ProductionReport,
  QuotesReport,
  Rankings,
  ReportMonths,
  RevenueLimitReport,
} from '@deizi/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export const reportsKey = ['reports'] as const;

export const useMonthReport = (month: string) =>
  useQuery({
    queryKey: [...reportsKey, 'month', month],
    queryFn: () => api.get(`/reports/month?month=${month}`, MonthReport),
    placeholderData: (prev) => prev,
  });

export const useRankings = (month: string) =>
  useQuery({
    queryKey: [...reportsKey, 'rankings', month],
    queryFn: () => api.get(`/reports/rankings?month=${month}`, Rankings),
    placeholderData: (prev) => prev,
  });

export const useProduction = (month: string) =>
  useQuery({
    queryKey: [...reportsKey, 'production', month],
    queryFn: () => api.get(`/reports/production?month=${month}`, ProductionReport),
    placeholderData: (prev) => prev,
  });

export const useQuotesReport = (month: string) =>
  useQuery({
    queryKey: [...reportsKey, 'quotes', month],
    queryFn: () => api.get(`/reports/quotes?month=${month}`, QuotesReport),
    placeholderData: (prev) => prev,
  });

export const useReportMonths = () =>
  useQuery({
    queryKey: [...reportsKey, 'months'],
    queryFn: () => api.get('/reports/months', ReportMonths),
  });

export const usePayback = () =>
  useQuery({
    queryKey: [...reportsKey, 'payback'],
    queryFn: () => api.get('/reports/payback', PaybackReport),
  });

export const useRevenueLimit = (year: number) =>
  useQuery({
    queryKey: [...reportsKey, 'revenue-limit', year],
    queryFn: () => api.get(`/reports/revenue-limit?year=${year}`, RevenueLimitReport),
  });

export const useProductStats = (productId: string, months = 3) =>
  useQuery({
    queryKey: [...reportsKey, 'product', productId, months],
    queryFn: () => api.get(`/products/${productId}/stats?months=${months}`, ProductStats),
  });
